/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, identity, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { CheckUsageDto } from '../common';
import { CheckUsageMapper } from '../common/check-usage.mapper';
import { CpStageDto, CriticalPathDetailsDto, CriticalPathSaveDto } from './critical-path.dto';
import { CriticalPathDetailsMapper, CriticalPathSaveMapper } from './critical-path.mapper';

@Injectable()
export class CriticalPathRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(): Observable<CriticalPathDetailsDto> {
    return this.httpGet(`${this.bp}/critical-path`, CriticalPathDetailsMapper);
  }

  save(criticalPath: CriticalPathSaveDto): Observable<CriticalPathDetailsDto> {
    return this.httpPut(`${this.bp}/critical-path`, criticalPath, CriticalPathSaveMapper, CriticalPathDetailsMapper);
  }

  checkUsage(stage: CpStageDto): Observable<CheckUsageDto> {
    const { criticalPathId, substituteId, version } = stage;
    return this.httpPost(
      `${this.bp}/critical-path/${criticalPathId}/check-usage`,
      { criticalPathId, substituteId, version },
      identity(),
      CheckUsageMapper,
    );
  }
}
